import { ref, getCurrentScope, onScopeDispose } from "vue";
import { usePolling } from "@/common/composables/polling";
import ConversationApi from "@/api/conversation";
import { ResponseState } from "../types";
const needsPolling = (response) => {
    return response.state === ResponseState.DRAFT || !response.summary?.content;
};
export const useConversationResponse = (initialResponse) => {
    const response = ref(initialResponse);
    let regenerateTimer = null;
    const { isPolling, start, stop } = usePolling(async () => {
        try {
            const updated = await ConversationApi.getConversationResponse(initialResponse.conversationId);
            response.value = updated;
            return !needsPolling(updated);
        }
        catch {
            return false;
        }
    }, { intervalMs: 5000 });
    if (needsPolling(initialResponse)) {
        start();
    }
    const regenerateSummary = async () => {
        await ConversationApi.regenerateSummary(initialResponse.conversationId);
        response.value.summary = undefined;
        stop();
        if (regenerateTimer)
            clearTimeout(regenerateTimer);
        regenerateTimer = setTimeout(start, 3000);
    };
    if (getCurrentScope()) {
        onScopeDispose(() => {
            if (regenerateTimer)
                clearTimeout(regenerateTimer);
        });
    }
    return { response, isPolling, regenerateSummary };
};
